<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-clicksign p-5">
      <div v-if="currentStep == 1">
        <button class="btn text-secondary close" @click="visible = false">
          <i class="icon-x" />
        </button>
        <div>
          <strong>
            Integração Clicksign
          </strong>
        </div>
        <div class="d-flex align-items-center mb-5">
          <small class="text-dark flex-fill mt-5">
            <a
              target="_blank"
              href="https://www.clicksign.com"
              class="text-primary font-weight-bold text-decoration-none"
            >
              Conheça a Clicksign
            </a>
          </small>
        </div>
        <hr />
        <form-group
          label="Token"
          id="url"
          v-model="form.token"
          :errors="errors.token"
          placeholder="Digite o Token da integração..."
        />
        <form-group
          label="Descrição da integração (Opcional)"
          id="description"
          v-model="form.description"
          :errors="errors.description"
          placeholder="Digite a descrição da integração..."
        />

        <div class="row pt-5">
          <div class="col-6">
            <button
              class="btn btn-block btn-outline-secondary"
              @click="visible = false"
            >
              Cancelar
            </button>
          </div>
          <div class="col-6">
            <button
              class="btn btn-block btn-primary"
              :disabled="!form.token"
              :class="{ 'bg-secondary border-secondary': !form.token }"
              @click="next"
            >
              <loading :show="loading">
                Próximo
              </loading>
            </button>
          </div>
        </div>
      </div>
      <div v-if="currentStep == 2" class="pt-5">
        <button class="btn text-secondary close" @click="visible = false">
          <i class="icon-x" />
        </button>
        <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
          <form-group
            slim
            select
            id="product-select"
            label="Nome do produto"
            v-model="form.product_id"
            placeholder="Selecionar produto..."
            :options="products"
          />
        </action-dispatcher>

        <label class="pt-3"> Selecionar documento </label>
        <dashed-add-resource
          icon="upload"
          title="Upload de arquivo"
          subTitle="Adicione um arquivo que tenha no máximo 5MB."
        >
          <input type="file" @change="addDocument($event.target.files)" />
        </dashed-add-resource>

        <div
          v-if="form.document.name"
          class="file-wrapper d-flex align-items-center px-5 mb-5"
        >
          <div class="flex-fill">
            <i class="icon-pdf" />
            <span>
              {{ form.document.name }}
            </span>
          </div>
          <button
            class="btn btn-sm delete-button"
            type="button"
            @click="clearDocuments"
          >
            <i class="icon-trash" />
          </button>
        </div>

        <div class="row pt-5">
          <div class="col-6">
            <button
              class="btn btn-block btn-outline-secondary"
              @click="previous"
            >
              Voltar
            </button>
          </div>
          <div class="col-6">
            <button
              class="btn btn-block btn-primary"
              :disabled="!isValid || loading"
              :class="{
                'bg-secondary border-secondary': !isValid || loading
              }"
              @click="submit"
            >
              <loading :show="loading">
                Salvar
              </loading>
            </button>
          </div>
        </div>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import DashedAddResource from "@/components/product/details/content/step02/DashedAddResource.vue";
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  components: { DashedAddResource },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "token",
          "description",
          "product_id",
          "document",
          "integration_id",
          "event_id"
        ],
        {
          document: { name: "", id: "" }
        }
      ),
      loading: false,
      visible: false,
      currentStep: 1
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.$emit("update-list");
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    },
    products(val) {
      if (this.integrationToEdit && this.integrationToEdit.product_name) {
        this.form.product_id = val.find(i => {
          return (
            i.name.toLowerCase() ===
            this.integrationToEdit.product_name.toLowerCase()
          );
        }).id;
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.product_id && this.form.document.id;
    }
  },
  methods: {
    previous() {
      this.currentStep = 1;
    },
    async next() {
      if (this.loading) return;

      this.loading = true;

      try {
        if (!this.integrationToEdit) {
          const data = await this.$store.dispatch(
            "integration/postClicksignIntegration",
            {
              token: this.form.token,
              description: this.form.description
            }
          );
          this.form.integration_id = data;
          this.currentStep = 2;
        } else {
          this.form.integration_id = this.integrationToEdit.id;
          await this.$store.dispatch("integration/putClicksignIntegration", {
            integration_id: this.form.integration_id,
            token: this.form.token,
            description: this.form.description
          });
          const data = await this.$store.dispatch(
            "integration/getClicksignEvent",
            this.form.integration_id
          );
          if (data.count) {
            this.form.event_id = data.results[0].id;
            const resp_data = await this.$store.dispatch(
              "integration/getDocument",
              {
                integration_id: this.form.integration_id,
                event_id: this.form.event_id
              }
            );
            this.form.document.name = resp_data.metadata.document_name;
            this.form.document.id = resp_data.metadata.document_id;
          }
          this.currentStep = 2;
        }
      } catch (e) {
        this.handleErrors(
          e,
          "TRANSLATE_FIELD_INTEGRATION_MAP",
          "Erro ao salvar configuração"
        );
      } finally {
        this.loading = false;
      }
    },
    addDocument(document) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(
        Math.floor(Math.log(document[0].size) / Math.log(1024))
      );
      const size =
        Math.round(document[0].size / Math.pow(1024, i), 2) + " " + sizes[i]; // convert to mb and show unit meansurement

      if ((size.match("MB") && /([^MB]*)MB/.exec(size)[1] > 5) || i > 2) {
        this.$message.error("O arquivo deve ter no máximo 5MB");
        return;
      }
      const reader = new FileReader();
      reader.fileName = document[0].name;

      reader.onload = e => {
        this.$store
          .dispatch("integration/createDocument", {
            integration_id: this.form.integration_id,
            file: reader.result,
            name: e.target.fileName
          })
          .then(data => {
            this.form.document.id = data.document_id;
            this.form.document.name = document[0].name;
          })
          .catch(e => {
            this.handleErrors(
              e,
              "TRANSLATE_FIELD_INTEGRATION_MAP",
              "Erro ao salvar documento"
            );
          });
      };
      reader.readAsDataURL(document[0]);
    },
    clear() {
      this.currentStep = 1;
      this.$emit("clear-edit");
      this.form = { product_id: "", document: { name: "", id: "" } };
    },
    clearDocuments() {
      this.form.document = { name: "", id: "" };
    },
    submit() {
      this.loading = true;

      const action = this.form.event_id
        ? "integration/putClicksignEvent"
        : "integration/postClicksignEvent";

      const data = {
        integration_id: this.form.integration_id,
        event_id: this.form.event_id,
        params: {
          product_id: this.form.product_id,
          metadata: {
            document_id: this.form.document.id,
            document_name: this.form.document.name
          }
        }
      };

      this.$store
        .dispatch(action, data)
        .then()
        .catch(error => {
          this.handleErrors(
            error,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          );
        })
        .finally(() => {
          this.loading = false;
          this.visible = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-clicksign {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }
  button {
    i {
      font-size: 28px;
    }
  }
  label {
    font-weight: 400;
    color: #736d80;
    font-size: 13px;
  }
  .file-wrapper {
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    font-size: 12px;
  }
  .delete-button {
    i {
      font-size: 24px;
      color: red;
    }
  }
}
</style>
